module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/link-3130ccf543b168c6693bb2b7a1ccdaca.svg";